import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { StaticContext } from 'react-router';
import { Prompt, RouteComponentProps, useParams } from 'react-router-dom';
import Headers from '~/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import { SCREENS } from '~/constants/screens';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import MessageCampaignForm from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignEditScreen/components/MessageCampaignForm/MessageCampaignForm';
import { messageCampaignStore } from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignEditScreen/store/messageCampaignStore';
import { getPromptProps } from '~/view/components/CustomPrompt/helper';
import { localeStore } from '~/mobx/localesStore';
import './style.scss';

type IProps = RouteComponentProps<{ id?: string }, StaticContext, undefined>;

const MessageCampaignEdit: React.FC<IProps> = observer((): JSX.Element => {
  const { id: campaignId } = useParams<{ id?: string }>();

  useEffect(() => {
    if (campaignId) messageCampaignStore.fetchCampaignSettings(campaignId);

    return () => {
      messageCampaignStore.resetForm();
    };
  }, []);

  return (
    <div className="d-flex flex-column flex-grow-1 position-relative">
      <Headers>
        <HeaderBack
          title={messageCampaignStore.form.subject || campaignId ? messageCampaignStore.form.subject : localeStore.t('marketing_mc_new_message_hdr')}
          noTranslation
          path={SCREENS.MESSAGE_CAMPAIGNS()}
        />
      </Headers>

      <ScrollableBlock showScrollbar className="full-height mt-6 expand-scroll-block">
        <MessageCampaignForm />
      </ScrollableBlock>

      <LoadingOverlay visible={messageCampaignStore.loading} refreshing />
      <Prompt when={messageCampaignStore.isEdited} message={getPromptProps()} />
    </div>
  );
});

export default MessageCampaignEdit;
